import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/x/avgEngagementRateHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/x/bestTimeToPost';
import { likesHistoryConfig } from '@/lib/analytics/charts/x/likesHistory';
import { postEngagementTimelineConfig } from '@/lib/analytics/charts/x/postEngagementTimeline';
import { postsDistributionConfig } from '@/lib/analytics/charts/x/postsDistribution';
import { postsHistoryConfig } from '@/lib/analytics/charts/x/postsHistory';
import { repliesHistoryConfig } from '@/lib/analytics/charts/x/repliesHistory';
import { repostsHistoryConfig } from '@/lib/analytics/charts/x/repostsHistory';
import { avgBookmarksPerPostConfig } from '@/lib/analytics/kpis/x/avgBookmarksPerPost';
import { avgEngagementOnImpressionsPerPostConfig } from '@/lib/analytics/kpis/x/avgEngagementOnImpressionsPerPost';
import { avgEngagementRatePerPostConfig } from '@/lib/analytics/kpis/x/avgEngagementRatePerPost';
import { avgLikesPerPostConfig } from '@/lib/analytics/kpis/x/avgLikesPerPost';
import { avgQuotesPerPostConfig } from '@/lib/analytics/kpis/x/avgQuotesPerPost';
import { avgRepliesPerPostConfig } from '@/lib/analytics/kpis/x/avgRepliesPerPost';
import { avgRepostsPerPostConfig } from '@/lib/analytics/kpis/x/avgRepostsPerPost';
import { bookmarkCountConfig } from '@/lib/analytics/kpis/x/bookmarkCount';
import { totalLikeCountConfig } from '@/lib/analytics/kpis/x/totalLikeCount';
import { totalQuoteCountConfig } from '@/lib/analytics/kpis/x/totalQuoteCount';
import { totalReplyCountConfig } from '@/lib/analytics/kpis/x/totalReplyCount';
import { totalRepostCountConfig } from '@/lib/analytics/kpis/x/totalRepostCount';
import { postRankingConfig } from '@/lib/analytics/widget/x/postRanking';
import { SIZE_25, SIZE_50, SIZE_FULL } from '@/lib/gridElements/size';

export const EngagementX = [
    // 1
    { ...avgEngagementRatePerPostConfig, size: SIZE_50 },
    { ...avgEngagementOnImpressionsPerPostConfig, size: SIZE_50 },

    // 2
    { ...avgEngagementRateHistoryConfig, size: SIZE_FULL },

    // 3
    { ...totalLikeCountConfig, size: SIZE_25 },
    { ...avgLikesPerPostConfig, size: SIZE_25 },
    { ...totalReplyCountConfig, size: SIZE_25 },
    { ...avgRepliesPerPostConfig, size: SIZE_25 },

    // 4
    { ...totalRepostCountConfig, size: SIZE_25 },
    { ...avgRepostsPerPostConfig, size: SIZE_25 },
    { ...totalQuoteCountConfig, size: SIZE_25 },
    { ...avgQuotesPerPostConfig, size: SIZE_25 },

    // 5
    bookmarkCountConfig,
    avgBookmarksPerPostConfig,

    // 6
    postEngagementTimelineConfig,

    // 7
    {
        ...postRankingConfig,
        sortFields: ['engagement_rate', 'created', 'impressions', 'likes', 'comments', 'shares']
    },

    // 8
    bestTimeToPostConfig,

    // 9
    postsHistoryConfig,
    { ...likesHistoryConfig, size: SIZE_50 },

    // 10
    repliesHistoryConfig,
    repostsHistoryConfig,

    // 11
    postsDistributionConfig
];

export const requestXEngagementParams = [
    // TwitterMedia + X API v2 metrics
    [
        'average_engagement_on_impressions_per_post',
        'average_engagement_rate_per_post',
        'average_engagement_rate_history',
        'post_engagements',
        'likes',
        'likes_organic',
        'likes_paid',
        'average_likes_per_post',
        'replies',
        'replies_organic',
        'replies_paid',
        'average_replies_per_post',
        'total_repost_count',
        'organic_repost_count',
        'promoted_repost_count',
        'average_reposts_per_post',
        'quote_count',
        'average_quotes_per_post',
        'bookmark_count',
        'average_bookmarks_per_post',
        'post_engagements_history',
        'posts_history',
        'likes_history',
        'replies_history',
        'reposts_history',
        'best_time_to_post',
        'posts_distribution'
    ]
];
